import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DialogsService } from '@toro/common/shared/services/dialogs.service';
import { CheckingAccountReceiptComponent } from '../../../dialogs/checking-account-receipt/checking-account-receipt.component';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { TrackingActions } from '@toro/common/shared/state-management/tracking/tracking.action';

@Component({
    selector: 'home-trader-bar',
    templateUrl: './home-trader-bar.component.html',
    styleUrls: ['./home-trader-bar.component.scss'],
})
export class HomeTraderBarComponent {

    constructor(
        protected store: Store<AppState>,
        private dialogsService: DialogsService,
        private router: Router
    ) {}

    public redirect(url: string, element: string) {
        this.sendTracking("Element Clicked", {
            'Product Area Origin': "Home Trader",
            'Time Responsável': "Brooklyn Dumbo",
            Element: element,
        });
        
        if(element == 'Depositar') {
            this.router.navigate(
                [url],
                { queryParams: { category: 'activeAccount' } },
            );
        } else {
            this.router.navigate([url]);
        }
    }

    /**
     * Método que abre o extrato do usuário
     */
    public openCheckingAccountReceipt() {
        this.sendTracking("Element Clicked", {
            'Product Area Origin': "Home Trader",
            'Time Responsável': "Brooklyn Dumbo",
            Element: 'Extrato',
        });
        this.dialogsService.showComponnent(
            CheckingAccountReceiptComponent,
            null
        );
    }

    public sendTracking(event: string, breakdowns: any) {
        this.store.dispatch({
          type: TrackingActions.trackEvents,
          payload: { type: event, events: breakdowns },
        });
    }
}
